

<div class="px-4 py-5 my-5 text-center">
  <a routerLink="/">

    <img class="d-block mx-auto mb-4" ngSrc="/assets/img/medilinkLogo.svg" alt="" width="500" height="200">
  </a>
  <h1 class="display-5 fw-bold " style="color: var(--primary-color)">{{ name }}</h1>
  <div class="col-lg-9 mx-auto">
    <p class="lead mb-4">{{intro}}</p>
  </div>
</div>

<div class="container mx-auto">
  <p class=" text-start fs-2 fw-bold" style="color:var(--primary-color);">Servicios</p>
  <p style="text-align: justify">{{textoServicios}}</p>
</div>

<div class="container mx-auto">
  <p class=" text-start fs-2 fw-bold" style="color:var(--primary-color);">Responsabilidad en el tratamiento de los datos personales.</p>
  <p style="text-align: justify">{{textoResponsabiliidad}}</p>
</div>

<div class="container mx-auto">
  <p class=" text-start fs-2 fw-bold" style="color:var(--primary-color);">Control de cambios</p>
  <p style="text-align: justify">{{textoControldeCambios}}</p>
</div>

<div class="container mx-auto" >
  <p class=" text-start fs-2 fw-bold" style="color:var(--primary-color);">DATOS REQUERIDOS POR MEDILINK</p>
  <div class="container">
    <p class=" text-start fs-2 fw-bold" style="color:var(--primary-color);">Datos Demográficos</p>
    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-5 py-5 justify-content-center ">
      <div class="col d-flex align-items-center " *ngFor="let datos of datosDemograficos">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6  ">{{ datos.nombre }}</h3>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <p class=" text-start fs-2 fw-bold" style="color:var(--primary-color);">Datos De Contacto</p>
    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-5 py-5 justify-content-center ">
      <div class="col d-flex align-items-center " *ngFor="let datos of datosContacto">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6  ">{{ datos.nombre }}</h3>
        </div>
      </div>
    </div>

  </div>

  <div class="container">
    <p class=" text-start fs-2 fw-bold" style="color:var(--primary-color);">Datos para Historia Clínica</p>
    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-5 py-5 justify-content-center ">
      <div class="col d-flex align-items-center " *ngFor="let datos of datosHistoriaClinica">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6  ">{{ datos.nombre }}</h3>
        </div>
      </div>
    </div>


  </div>

  <div class="container">
    <p class=" text-start fs-2 fw-bold" style="color:var(--primary-color);">Datos Tributarios</p>
    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-5 py-5 justify-content-center ">
      <div class="col d-flex align-items-center " *ngFor="let datos of datosTributarios">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6  ">{{ datos.nombre }}</h3>
        </div>
      </div>
    </div>


  </div>

  <div class="container">
    <p class=" text-start fs-2 fw-bold" style="color:var(--primary-color);">Datos Adicionales</p>
    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-5 py-5 justify-content-center ">
      <div class="col d-flex align-items-center " *ngFor="let datos of datosAdicionales">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6  ">{{ datos.nombre }}</h3>
        </div>
      </div>
    </div>


  </div>

  <div class="container">
    <p class=" text-start fs-2 fw-bold" style="color:var(--primary-color);">Uso de datos personales</p>
    <p style="text-align: justify;">{{textoUsodeDatos}}</p>
  </div>

  <div class="container">
    <p class=" text-start fs-2 fw-bold" style="color:var(--primary-color);">Uso compartido de la información</p>
    <p style="text-align: justify" [innerHTML]="textoCompartidoInformacion"></p>
  </div>

  <div class="container">
    <p class=" text-start fs-2 fw-bold" style="color:var(--primary-color);">Derechos y obligaciones del cliente/usuario</p>
    <p class=" text-start fs-3 fw-bold" style="color:var(--primary-color);">Plazo de Conservación de datos</p>
    <p style="text-align: justify" [innerHTML]="textoDerechosYObligaciones"></p>
    <p class=" text-start fs-3 fw-bold" style="color:var(--primary-color);">Derecho de acceso a los datos personales</p>
    <p style="text-align: justify" [innerHTML]="textoDerechoDatosPersonales"></p>
    <p class=" text-start fs-3 fw-bold" style="color:var(--primary-color);">Eliminación de datos personales.</p>
    <p style="text-align: justify" [innerHTML]="textoDerechoDatosPersonales"></p>
    <p class=" text-start fs-3 fw-bold" style="color:var(--primary-color);">Aclaración sobre la finalización de servicios</p>
    <p style="text-align: justify" [innerHTML]="textoFinalizacionServicios"></p>
    <p class=" text-start fs-3 fw-bold" style="color:var(--primary-color);">Canales de atención</p>
    <p>Requerimientos relaciones a la gestión de datos personales</p>
    <div class="container text-lg-start">
      <p>Correo electronico: <a href="mailto:{{correoElectronico}}">{{correoElectronico}}</a>  </p>
      <p>Formulario de Reclamos en página Web: <a href="{{formPaginaWeb}}">{{formPaginaWeb}}</a> </p>
      <p>ContactCenter : <br>
        Guayaquil - (04) 5 50 50 52 <br>
        Babahoyo - (05) 5 50 50 52 <br>
        Quito - (02) 5 50 50 52 <br>
        <a href="https://wa.me/59393183975">Whatsapp -  099 318 3975</a></p>

    </div>
  </div>
</div>

<app-footer-persona/>




